import React from 'react'
import PropTypes from 'prop-types'
import { LivestreamPageTemplate } from '../../templates/livestream-page'

const livestreamPagePreview = ({ entry, getAsset }) => {
  const data = entry.getIn(['data']).toJS()

  if (data) {
    return (
      <LivestreamPageTemplate
        backgroundimage={getAsset(data.backgroundimage)}
      />
    )
  } else {
    return <div>Loading...</div>
  }
}

livestreamPagePreview.propTypes = {
  entry: PropTypes.shape({
    getIn: PropTypes.func,
  }),
  getAsset: PropTypes.func,
}

export default livestreamPagePreview
